import React from 'react';
import { Column, Row, Button, cls } from '../../packages/components';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Assets from '../../requests/apa/Asset';
import PropTypes from 'prop-types';
import './styles/ModalLicenciaUso.scss';


const MAIN_CLASSNAME = 'aaf_app_modal-license';


const BodyContent = ({ props }) => {
    return (
        <div>
            <Row>
                LICENCIA DE USO
            </Row>
        </div>
    );
};

const ModalLicenciaUso = (props = {}) => {
    const customizedClassName = `modal-button-return`;
    const p = {
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: true,
        yellowAction: (e) => props.handleClose(e),
        colorButtons: 
            [
                {
                    content: Translator.get('top_head_option_button_back', 'REGRESAR'),
                    props: {
                        color: 'yellow',
                        className: customizedClassName,
                        imgSrc: Assets.get('top_head_option_back', ''),
                        onClick: (e) => props.handleClose(e, props.callback),
                    },
                },
              ]
            ,
    };
    return (
        <ModalWrapper {...p}>
            <BodyContent props={props} />
        </ModalWrapper>
    );
};

ModalLicenciaUso.propTypes = {
    content: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(ModalLicenciaUso);


// WEBPACK FOOTER //
// ./src/components/Modal/ModalLicenciaUso.jsx